import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, inject, OnInit } from '@angular/core';
import { PersonInterface } from '@campus/dal';
import { AuthFacade, FormFacade, LoginCredentials, UserType } from '@campus/public-portal';
import '@diekeure/dcr-components/dcr-filled-button.js';
import '@diekeure/dcr-components/dcr-focus-ring.js';
import '@diekeure/dcr-components/dcr-icon.js';
import '@diekeure/dcr-components/dcr-logo.js';
import '@diekeure/dcr-components/dcr-menu-item.js';
import '@diekeure/dcr-components/dcr-menu.js';
import '@diekeure/dcr-components/dcr-state-layer.js';
import '@diekeure/dcr-components/dcr-top-app-bar.js';
import { combineLatest, map, Observable } from 'rxjs';
import { AppViewModel } from '../../app.viewmodel';

export interface HeaderActionInterface {
  label: string;
  icon?: string;
  action?: () => void;
  children?: HeaderActionInterface[];
}

@Component({
  selector: 'campus-portal-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class PortalHeaderComponent implements OnInit {
  public headerLinks = [
    { id: 'polpo', label: 'Polpo', icon: 'portal:logo', route: { url: '#about' } },
    { id: 'dk', label: 'die Keure', icon: 'portal:diekeure', route: { url: '#diekeure' } },
    { id: 'faq', label: 'Vragen', icon: 'portal:faq', route: { url: '#faq' } },
    { id: 'contact', label: 'Contact', icon: 'portal:contact', route: { url: '#contact' } },
  ];

  public user$: Observable<PersonInterface>;
  public headerActions$: Observable<HeaderActionInterface>;
  public mobile$: Observable<boolean>;

  private isMaintenanceMode$: Observable<boolean>;
  private appViewModel = inject(AppViewModel);
  private form = inject(FormFacade);
  private auth = inject(AuthFacade);
  private breakpoint = inject(BreakpointObserver);

  public ngOnInit(): void {
    this.isMaintenanceMode$ = this.appViewModel.isMaintenanceMode$;
    this.user$ = this.auth.user$;
    this.headerActions$ = this.setHeaderActions$();

    this.mobile$ = this.breakpoint
      .observe([Breakpoints.XSmall, Breakpoints.Small])
      .pipe(map((result) => result.matches));
  }

  goToPlatform() {
    this.appViewModel.redirectToPlatform();
  }

  logout() {
    this.auth.logout();
  }

  login(credentials: LoginCredentials) {
    this.auth.login(credentials);
  }

  closeLoginForm() {
    this.form.closeLoginForm();
  }

  openLoginForm(userType: UserType) {
    this.form.openLoginForm(userType);
  }

  private setHeaderActions$() {
    return combineLatest([this.user$, this.isMaintenanceMode$]).pipe(
      map(([user, isMaintenanceMode]) => {
        if (isMaintenanceMode) {
          return null;
        } else if (user) {
          return {
            label: user.displayName,
            children: [
              {
                label: 'Naar het platform',
                icon: 'portal:rocket',
                action: () => this.goToPlatform(),
              },
              {
                label: 'Afmelden',
                icon: 'portal:logout',
                action: () => this.logout(),
              },
            ],
          };
        } else {
          return {
            label: 'Aanmelden',
            children: [
              {
                label: 'Aanmelden',
                href: '/login',
              },
              {
                label: 'Aanmelden als beheerder',
                href: '/login?role=schooladmin',
              },
            ],
          };
        }
      })
    );
  }
}
